import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, effect, inject, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { WooComponentsModule } from '@scripts/woo_components.module/module';
import { DashboardService } from '@scripts/woo_services.module/DashboardService';
import { CompactCampaign, CompactCustomer } from '@scripts/woo_services.module/shared-types';
import { DotLoader } from '@src/shared/feedback/loader/dot-loader.component';
import { BaseModalComponent } from '@src/shared/modal/base-modal/base-modal.component';
import { ModalLayoutComponent } from '@src/shared/modal/base-modal/modal-layout/modal-layout.component';

@Component({
  selector: 'campaign-selection-modal',
  imports: [CommonModule, FormsModule, ModalLayoutComponent, DotLoader, WooComponentsModule],
  templateUrl: './campaign-selection-modal.component.html',
  styleUrl: './campaign-selection-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CampaignSelectionModalComponent extends BaseModalComponent<{
  customers: CompactCustomer[];
}> {
  dashboardService = inject(DashboardService);
  customers = computed(() => this.modaldata().customers);
  campaigns = signal<CompactCampaign[]>([]);
  availableCampaigns = computed(() => this.campaigns().filter((c) => !c.ttv_campaign));
  submit = output<CompactCampaign | void>();
  loading = signal(false);

  selectedCustomer = signal<CompactCustomer | null>(null);
  selectedCampaign = signal<CompactCampaign | null>(null);

  showSelectInput = computed(() => this.customers().length > 1);

  showCampaignSelectInput = computed(() => {
    return this.campaigns().length > 0 && this.selectedCustomer();
  });

  autoSelectSingle = effect(() => {
    const list = this.customers();
    if (list.length === 1 && !this.selectedCustomer()) {
      this.selectedCustomer.set(list[0]);
    }
  });

  getAvailableCampaigns = effect(() => {
    this.selectedCampaign.set(null);
    const id = this.selectedCustomer()?.id;
    if (!id) {
      this.campaigns.set([]);
      return;
    }

    this.loading.set(true);
    this.dashboardService
      .getAllCampaignsForCustomer(id, ['name', 'id', 'ttv_campaign'], 'start_date')
      .then((cs) => this.campaigns.set(cs.filter((c) => !c.ttv_campaign)))
      .catch((err) => console.error(err))
      .finally(() => this.loading.set(false));
  });
}
